/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {ReactNode} from 'react';
// style
import {StyledModal} from './Modal.style';
import {getStaticModalIconUrl} from './ModalUtils';
import {Avatar} from '@mui/material';

interface ModalProps {
  visible: boolean;
  onClose?: () => void;
  children: ReactNode;
  fullScreen?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  iconVariant?: string;
}

function Modal({
  visible,
  onClose,
  fullScreen,
  children,
  maxWidth = 'xs',
  iconVariant,
}: ModalProps) {
  const modalIcon = getStaticModalIconUrl(iconVariant);
  return (
    <StyledModal
      open={visible}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth={maxWidth}
      fullWidth
      sx={theme => ({
        '& .MuiDialog-paper': {
          backgroundColor: 'transparent',
          pt: modalIcon ? 20 : 0,
          '&::before': {
            content: '""',
            position: 'absolute',
            top: modalIcon ? 40 : 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.palette.common.white,
            borderRadius: 1,
            zIndex: -1,
          },
        },
      })}
    >
      {modalIcon && (
        <Avatar
          src={modalIcon}
          sx={{
            width: 80,
            height: 80,
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        />
      )}
      {children}
    </StyledModal>
  );
}
export default Modal;
